import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";
import { Enterprise } from "../types";

const fetchEnterprise = async (): Promise<Enterprise[]> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getEnterprise",
		bind: {},
	});

	return response.data.result;
};

export const useGetEnterprise = () => {
	return useQuery<Enterprise[], Error, Enterprise>({
		queryKey: ["getEnterprise"],
		queryFn: () => fetchEnterprise(),
		select: (data) => data[0],
	});
};

/*
useQuery<Enterprise[], Error, Enterprise>
           ^           ^        ^
           |           |        |
     data from     possible   transformed
     queryFn       error      return value (after select)
*/
